"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { FileCheck, Clock, Check, Shield } from "lucide-react";
export default function WhyLeadersUseArmyWritingTools() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref4,
    isVisible: isVisible4
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const benefits = [{
    icon: FileCheck,
    label: "Regulation-Aligned Output",
    ref: ref1,
    isVisible: isVisible1
  }, {
    icon: Clock,
    label: "Time Savings",
    ref: ref2,
    isVisible: isVisible2
  }, {
    icon: Check,
    label: "Consistency",
    ref: ref3,
    isVisible: isVisible3
  }, {
    icon: Shield,
    label: "Army-Specific Design",
    ref: ref4,
    isVisible: isVisible4
  }];
  return <section id="why-leaders-use-army-writing-tools" className="bg-light-background py-16 px-6">
      <div className="mx-auto max-w-7xl">
        <h2 className="font-display text-center text-3xl font-semibold text-foreground-light mb-12">
          Why Leaders Use Army Writing Tools
        </h2>
        
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <div key={i} data-index={i} ref={benefit.ref} className={`transition-all duration-200 ease-out ${benefit.isVisible ? "translate-y-0 opacity-100" : "translate-y-[10px] opacity-0"}`}>
                <Card className="h-full hover:shadow-medium hover:-translate-y-1 transition-all duration-[250ms] ease-[cubic-bezier(0.22,1,0.36,1)] group">
                  <CardContent className="flex flex-col items-center justify-center gap-4 py-8 px-6">
                    <div className="rounded-full bg-primary-light p-4 transition-all duration-[250ms] group-hover:outline group-hover:outline-2 group-hover:outline-primary">
                      <Icon className="h-8 w-8 text-primary" strokeWidth={2} />
                    </div>
                    <p className="text-center text-base font-medium text-foreground-light transition-all duration-[250ms] group-hover:font-semibold">
                      {benefit.label}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}